import gql from "graphql-tag";

export const downloadCatalogue = gql`
  query downloadCatalogue {
    nodeQuery(filter: { conditions: [{ field: "type", value: "Catalogue" }] }) {
      entities {
        ... on NodeCatalogue {
          fieldPdfFile {
            entity {
              url
            }
          }
        }
      }
    }
  }
`;

export const currencyById = gql`
  query CurrencyById($id: String!) {
    nodeById(id: $id) {
      ... on NodeCurrency {
        fieldCurrencySign
        fieldCurrencyName
      }
    }
  }
`;

export const countriesTaxonomyQuery = gql`
  query genericTaxonomyQuery($vid: String!) {
    taxonomygenericviewGraphql1View(filter: { vid: $vid }) {
      results {
        ... on TaxonomyTermAvailablecountriesforaddress {
          tid
          name
          fieldCountryCode
        }
      }
    }
  }
`;

export const categoriesTaxonomyQuery = gql`
  query categoriesTaxonomyQuery($vid: String!, $lang: String!) {
    taxonomygenericviewGraphql1View(filter: { vid: $vid, langcode: $lang }) {
      results {
        ... on TaxonomyTermProductCategories {
          tid
          name
          weight
          fieldIconName {
            targetId
            entity {
              name
            }
          }
          fieldDescription
          fieldPromotedToFrontPage
          parent {
            targetId
            entity {
              name
            }
          }
        }
      }
    }
  }
`;

export const productCategoriesTaxonomyQuery = gql`
  query productCategoriesTaxonomyQuery($vid: String!, $lang: String!) {
    taxonomygenericviewGraphql1View(filter: { vid: $vid, langcode: $lang }) {
      results {
        ... on TaxonomyTermProductCategories {
          tid
          name
          weight
          parent {
            targetId
            entity {
              name
            }
          }
        }
      }
    }
  }
`;

export const registrationTexts = gql`
  query registrationTexts($lang: String!) {
    nodeQuery(filter: { type: "registration_sidebar", langcode: $lang }) {
      entities {
        ... on NodeRegistrationSidebar {
          nid
          fieldSidebarLines {
            entity {
              ... on ParagraphRegistrationSidebarLine {
                fieldLineText
                fieldIconName {
                  targetId
                  entity {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const mainSlider = gql`
  query mainSlider($lang: String!) {
    mainSliderGraphql1View(filter: { langcode: $lang }) {
      results {
        fieldSlides {
          targetId
          entity {
            ... on ParagraphSlide {
              fieldTitle
              fieldDescription
              fieldLink {
                url {
                  path
                }
                title
              }
              fieldInternalLinkText
              fieldProductReference {
                targetId
              }
              fieldImage {
                url
              }
              fieldBackgroundImage {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const getHomeProductsCategories = gql`
  query RandomProductsInHome($lang: String!) {
    taxonomygenericviewGraphql1View(
      filter: {
        langcode: $lang
        vid: "product_categories"
        random_products_in_home: "true"
      }
    ) {
      results {
        ... on TaxonomyTermProductCategories {
          tid
          name
          parent {
            targetId
          }
        }
      }
    }
  }
`;

export const getCategoryProductsSubategories = gql`
  query RandomProductsInCategories($lang: String!) {
    taxonomygenericviewGraphql1View(
      filter: { langcode: $lang, vid: "product_categories" }
    ) {
      results {
        ... on TaxonomyTermProductCategories {
          tid
          name
          parent {
            targetId
          }
        }
      }
    }
  }
`;

export const basicPage = gql`
  query basicPage($type: String!) {
    pagebytypeGraphql1View(filter: { field_page_type_value: $type }) {
      results {
        title
        body {
          format
          processed
        }
      }
    }
  }
`;

export const getText = gql`
  query getText($machineName: String!, $lang: String!) {
    translationMetadataGraphql1View(
      filter: { field_machine_name_value: $machineName, langcode: $lang }
    ) {
      results {
        fieldMainText
        fieldSubText
        fieldMachineName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/utils.js